import { render } from "./accountOrdersListDetails.vue?vue&type=template&id=c2769330"
import script from "./accountOrdersListDetails.vue?vue&type=script&lang=js"
export * from "./accountOrdersListDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__